module.exports = __webpack_public_path__ + "img/js_icon.1d1a661.png";